import React from 'react';

import { CONTENTS } from '@lumapps/contents/keys';
import { useDataAttributes } from '@lumapps/data-attributes';
import { CONTENT_EDITOR_TOPBAR_SCOPE } from '@lumapps/designer/constants';
import { Link as LumxLink } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

export const ShowRequestRevisionDetailsLink = ({ onClick }: { onClick: () => void }) => {
    const { translateKey } = useTranslate();
    const { get } = useDataAttributes(CONTENT_EDITOR_TOPBAR_SCOPE);

    return (
        <LumxLink
            onClick={onClick}
            typography="body1"
            color="red"
            colorVariant="N"
            {...get({ element: 'request-revision-reason', action: 'open-details' })}
        >
            {translateKey(CONTENTS.REVISION_REQUESTED)}
        </LumxLink>
    );
};
